module.exports = __webpack_public_path__ + "img/comment-dots-regular-red.20943495.svg";